import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {DMSConfigService} from '../services/dmsconfig.service';
import { Observable } from 'rxjs';
import {OAuthService} from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    private readonly http: HttpClient,
    private readonly dmsConfigService: DMSConfigService,
    private readonly oauthService: OAuthService) {
  }

  clearCustomerCookie(): void {
    const httpHeaders: HttpHeaders = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`);
    const authCustomerUrl = this.dmsConfigService.getConfig().API_GATEWAY_AUTHENTICATION_URL;
    this.http.delete<void>(authCustomerUrl, {headers: httpHeaders})
      .subscribe({
        next: this.onClearCustomerCookie,
        error: this.onClearCustomerCookie
      });
  }

  private readonly onClearCustomerCookie = (): void => {
    this.oauthService.logOut();
  }
}
